import {isUndefined} from 'lodash';
import {URLSearchParams} from '@angular/http';

export class URLSearch {

    private $search: URLSearchParams;

    constructor($search: URLSearchParams) {
        this.$search = $search;
    }

    static builder(): URLSearch {
        return new URLSearch(new URLSearchParams());
    }

    static toSearch(data: any): URLSearchParams {
        let builder: URLSearch = URLSearch.builder();

        if (!isUndefined(data)) {
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    builder.append(key, data[key])
                }
            }
        }

        return builder.build();
    }

    public append(name: string, value: any) {
        this.$search.append(name, value);
        return this;
    }

    public build(): URLSearchParams {
        return this.$search;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/core/http/client.http.utils.ts